import React from 'react';
import styles from './LoanCalculatorWidget.scss';
import LocalStorage from '../../utils/LocalStorage';
import PercentInput from './PercentInput';
import EuroInput from './EuroInput';
import Select from './Select';
import Formatter from './Formatter';
import Calculator, { ICalculatorValues } from './Calculator';
import { ILoanRequestAddSubmit, ILoanRequestLoanCalculator } from '../../utils/LoanRequest';
import FixedButton from '../FixedButton';
import SyncFixedBottom from '../SyncFixedBottom';
import Responsive from '../../utils/Responsive';
import { ILoanCalculatorTextKeys } from './LoanCalculatorPage';
import Tooltip from '../Tooltip';
import AssessmentIcon from '@mui/icons-material/Assessment';

export interface ILoanCalculatorWidgetProps {
    price: number;
    calcParams: ICalculatorValues;
    // uuid: string; // property id
    onNextStep: (data: any) => void;
    data: ILoanRequestAddSubmit['loanCalculator'];
    syncRef: React.RefObject<HTMLDivElement>;
    textKeys?: ILoanCalculatorTextKeys['step1'];
}

export interface ILoanCalculatorWidgetState extends ILoanRequestLoanCalculator {
    // showDetails: boolean;
    showClosingCostsDetails: boolean;
    showEquityDetails: boolean;

    // /**
    //  * Kaufpreis
    //  */
    // price: number;

    // /**
    //  * Kaufnebenkosten
    //  */
    // closingCostsPercentage: number;

    // /**
    //  * Grunderwerbssteuer
    //  */
    // stampDutyPercentage: number;

    // /**
    //  * Notarkosten
    //  */
    // notarialCostsPercentage: number;

    // /**
    //  * Grundbucheintrag
    //  */
    // landRegisterCostsPercentage: number;

    // /**
    //  * Maklerprovision
    //  */
    // findersFeePercentage: number;

    // /**
    //  * Eigenkapital
    //  *
    //  */
    // equity: number;

    // /**
    //  * Tilgungsrate
    //  */
    // amortizationRatePercentage: number;

    // /**
    //  * Sollzinsbindung
    //  */
    // fixedInterestRateYears: number;

    // equityBank: number;
    // equityStock: number;
    // equityBuildingSociety: number;
    // equityAssurence: number;
    // equityMiscellaneous: number;
}

export default class LoanCalculatorWidget extends React.Component<ILoanCalculatorWidgetProps, ILoanCalculatorWidgetState> {
    // bottomRef: React.RefObject<HTMLDivElement> = null;

    protected containerRef: React.RefObject<HTMLDivElement> = null;

    constructor(props: ILoanCalculatorWidgetProps) {
        super(props);

        const calc = new Calculator(props.price, null, props.calcParams);

        this.state = {
            // showDetails: false,
            showClosingCostsDetails: false,
            showEquityDetails: false,

            price: props.price || 250000,
            closingCostsPercentage: calc.getKaufnebenkosten(),
            stampDutyPercentage: calc.getGrunderwerbssteuer(),
            notarialCostsPercentage: calc.getNotarkosten(),
            landRegisterCostsPercentage: calc.getGrundbucheintrag(),
            findersFeePercentage: calc.getMaklerprovision(),
            amortizationRatePercentage: calc.getTilgungsrate(),
            fixedInterestRateYears: calc.getSollzinsbindung(),

            equity: LocalStorage.getItem('lastLoanCalculatorEquity') || calc.getEigenkapital(),
            equityBank: calc.getBankguthaben(),
            equityStock: calc.getWertpapiere(),
            equityBuildingSociety: calc.getBausparguthaben(),
            equityAssurence: calc.getLebensversicherung(),
            equityMiscellaneous: calc.getSonstiges(),

            // overwrite with props, wenn data was already entered (after history back)
            ...props.data,
        };

        // this.bottomRef = React.createRef();
        this.containerRef = React.createRef();
    }

    public componentWillReceiveProps = (props: ILoanCalculatorWidgetProps) => {
        if (props.price !== this.state.price) {
            this.setState({ price: props.price, equityBank: props.price / 5 });
        }
    };

    render() {
        // const { price } = this.props;
        const {
            // showDetails,
            showClosingCostsDetails,
            showEquityDetails,
            price,
            stampDutyPercentage: stampDuty,
            notarialCostsPercentage: notarialCosts,
            landRegisterCostsPercentage: landRegisterCosts,
            findersFeePercentage: findersFee,
            amortizationRatePercentage,
            fixedInterestRateYears,

            equity,
            equityBank,
            equityStock,
            equityBuildingSociety,
            equityAssurence,
            equityMiscellaneous,
        } = this.state;

        let { closingCostsPercentage: closingCosts } = this.state;

        if (showClosingCostsDetails) {
            closingCosts = stampDuty + notarialCosts + landRegisterCosts + findersFee;
        }

        const calc = new Calculator(
            price,
            equity,
            {
                stampDuty,
                notarialCosts,
                landRegisterCosts,
                findersFee,
                amortizationRate: amortizationRatePercentage,
                fixedInterestRate: fixedInterestRateYears,
            },
            {
                bank: equityBank,
                stock: equityStock,
                buildingSociety: equityBuildingSociety,
                assurence: equityAssurence,
                miscellaneous: equityMiscellaneous,
            }
        );

        return (
            <div className={styles.loanCalculatorWidget} ref={this.containerRef}>
                <form
                    className={styles.box}
                    action="#"
                    onSubmit={this.handleGoToLoanRequest}
                // onSubmit={(ev: React.FormEvent<HTMLFormElement>) => {
                //     ev.currentTarget
                //         .getElementsByTagName('input')
                //         .item(0)
                //         .blur();
                //     ev.preventDefault();
                // }}
                >
                    <EuroInput theme="head" label="Kaufpreis" pattern="\d*." value={price ? price : 0} name="price" onChange={this.handleValueChange} />
                    <hr />
                    <dl className={styles.closingCosts + ' ' + (showClosingCostsDetails ? styles.open : null)}>
                        <dt>
                            <span className={styles.sign}>+</span>Kaufnebenkosten
                        </dt>
                        <dd>
                            {Formatter.getEuroString(Math.round(calc.getKaufnebenkostenValue()))}{' '}
                            <span className={styles.percent}>({Formatter.getNumberString(calc.getKaufnebenkosten())} %)</span>
                        </dd>
                    </dl>

                    <div className={styles.closingCostsDetails + ' ' + (showClosingCostsDetails ? styles.open : '')}>
                        <PercentInput
                            base={price}
                            type="number"
                            pattern="\d*"
                            value={stampDuty ? stampDuty : 0}
                            name="stampDutyPercentage"
                            label="Grunderwerbssteuer"
                            onChange={this.handleValueChange}
                        />

                        <PercentInput
                            base={price}
                            type="number"
                            pattern="\d*"
                            value={notarialCosts ? notarialCosts : 0}
                            name="notarialCostsPercentage"
                            label="Notarkosten"
                            onChange={this.handleValueChange}
                        />
                        <PercentInput
                            base={price}
                            type="number"
                            pattern="\d*"
                            value={landRegisterCosts ? landRegisterCosts : 0}
                            name="landRegisterCostsPercentage"
                            label="Grundbucheintrag"
                            onChange={this.handleValueChange}
                        />
                        <PercentInput
                            base={price}
                            type="number"
                            pattern="\d*"
                            value={findersFee ? findersFee : 0}
                            name="findersFeePercentage"
                            label="Maklerprovision"
                            onChange={this.handleValueChange}
                        />
                    </div>
                    <a onClick={this.handleToggleClosingCostsDetails}>{showClosingCostsDetails ? 'Weniger Details' : 'Details einblenden'}</a>

                    <hr />
                    <div className={styles.equity}>
                        <EuroInput
                            theme="head"
                            // base={price}
                            // type="number"
                            pattern="\d*"
                            value={calc.getEigenkapital()}
                            name="equity"
                            // label={`\u2013 Eigenkapital`}
                            label={
                                <>
                                    <span className={styles.sign}>{'\u2013'}</span>Eigenkapital
                                </>
                            }
                            onChange={this.handleValueChange}
                        // disabled={showEquityDetails}
                        />
                        <div className={styles.annotation}>
                            {Formatter.getNumberString(Math.round((calc.getEigenkapital() / calc.getPreis()) * 1000) / 10)} % des Kaufpreises
                        </div>

                        <div className={styles.equityDetails + ' ' + (showEquityDetails ? styles.open : '')}>
                            <EuroInput
                                label="Bank- /Sparguthaben"
                                pattern="\d*."
                                value={equityBank ? equityBank : 0}
                                name="equityBank"
                                onChange={this.handleValueChange}
                            />
                            <EuroInput
                                label="Wertpapiere"
                                pattern="\d*."
                                value={equityStock ? equityStock : 0}
                                name="equityStock"
                                onChange={this.handleValueChange}
                            />
                            <EuroInput
                                label="Zuteilungsreifes Bausparguthaben"
                                pattern="\d*."
                                value={equityBuildingSociety ? equityBuildingSociety : 0}
                                name="equityBuildingSociety"
                                onChange={this.handleValueChange}
                            />
                            <EuroInput
                                label="Rückkaufswert Lebensversicherung"
                                pattern="\d*."
                                value={equityAssurence ? equityAssurence : 0}
                                name="equityAssurence"
                                onChange={this.handleValueChange}
                            />
                            <EuroInput
                                label="Sonstiges Vermögen"
                                pattern="\d*."
                                value={equityMiscellaneous ? equityMiscellaneous : 0}
                                name="equityMiscellaneous"
                                onChange={this.handleValueChange}
                            />
                        </div>

                        <a onClick={this.handleToggleEquityDetails}>
                            <AssessmentIcon />
                            <span>{showEquityDetails ? 'Weniger Details' : 'Details angeben'}</span>
                        </a>
                    </div>

                    <hr className={styles.big} />
                    <dl className={styles.loanSum}>
                        <dt>
                            <span className={styles.sign}>=</span>Nettodarlehen
                        </dt>
                        <dd>{Formatter.getEuroString(calc.getNettodarlehen())} </dd>
                    </dl>
                    <hr className={styles.bigGrey} />

                    <div className={styles.selects}>
                        <Select
                            label="Tilgungsrate"
                            value={amortizationRatePercentage ? amortizationRatePercentage.toString() : ''}
                            name="amortizationRatePercentage"
                            onChange={this.handleValueChange}
                            tooltip="Die Tilgungsrate ist Deine regelmäßig geleistete Rückzahlung Deines Darlehens an die Bank. Die Zinsen sind dabei nicht berücksichtigt!"
                        >
                            {calc.getAmortizationRateList().map((val) => {
                                return (
                                    <option key={val} value={val.toString()}>
                                        {Formatter.getNumberString(val)} %
                                    </option>
                                );
                            })}
                        </Select>

                        <Select
                            label="Sollzinsbindung"
                            value={fixedInterestRateYears ? fixedInterestRateYears.toString() : ''}
                            name="fixedInterestRateYears"
                            onChange={this.handleValueChange}
                            tooltip="Die Sollzinsbindung beschreibt einen festgelegten Zeitraum, in dem Du Deinen Immobilienkredit mithilfe einer festgelegten Tilgungsrate an die Bank zurückzahlst. Anders als bei normalen Ratenkrediten bleibt bei Baufinanzierungen in den meisten Fällen eine Restschuld vorhanden - diese wird durch eine Anschlussfinanzierung abbezahlt."
                        >
                            {calc.getFixedInterestRateList().map((val) => {
                                return (
                                    <option key={val} value={val.toString()}>
                                        {val} Jahre
                                    </option>
                                );
                            })}
                        </Select>
                    </div>

                    <SyncFixedBottom
                        className={styles.conditions}
                        syncWith={this.props.syncRef}
                        topOffset={65}
                        bottomOffset={45}
                        active={Responsive.getWidth() >= 993}
                        alignment="bottom"
                    >
                        <div className={styles.headline}>Kostenlos und unverbindlich Finanzierungsangebote einholen</div>
                        {/* <div className={styles.value}>
                            {Formatter.getEuroString(calc.getMonatsrate())}
                            <div className={styles.label}>Monatsrate</div>
                        </div> */}

                        <div className={styles.list}>
                            {/* <div>
                                <div className={styles.value}>{Formatter.getNumberString(calc.getSollzins())} %</div>
                                <div className={styles.label}>Geb. Sollzins</div>
                            </div> */}
                            <div>
                                <div className={styles.value}>{Formatter.getEuroString(Math.round(calc.getMonatsrate()))}</div>
                                <div className={styles.label}>Monatsrate</div>
                            </div>
                            <div>
                                <div className={styles.value}>{Formatter.getNumberString(calc.getEffektivzins())} %</div>
                                <div className={styles.label}>
                                    Eff. Jahreszins <Tooltip>Der effektive Jahreszins beinhaltet auch die Nebenkosten Deines Baudarlehens.</Tooltip>
                                </div>
                            </div>
                        </div>

                        <div className={styles.buttonContainer}>
                            <FixedButton type="submit" boundingRef={this.containerRef}>
                                {this.props.textKeys?.button}
                            </FixedButton>
                            <div className={styles.annotation}>Durchschnittliche Finanzierungskonditionen auf Basis Deiner Angaben</div>
                        </div>
                    </SyncFixedBottom>
                </form>

                <div className={styles.box + ' ' + styles.costOverview}>
                    Kosten der Finanzierung
                    <dl>
                        <dt>Summe aller Raten</dt>
                        <dd>{Formatter.getEuroString(calc.getRatensumme())}</dd>
                        <dt>davon gezahlte Zinsen</dt>
                        <dd>{Formatter.getEuroString(calc.getZinssumme())}</dd>
                        <dt>Getilgter Betrag</dt>
                        <dd>{Formatter.getEuroString(calc.getGetilgt())}</dd>
                        <dt>Restschuld zum Ende der Zinsbindung</dt>
                        <dd>{Formatter.getEuroString(calc.getRestschuld())}</dd>
                    </dl>
                </div>
                {/* <div ref={this.bottomRef} className={styles.bottom} /> */}
            </div>
        );
    }

    protected handleEquityChange = (equity: number) => {
        LocalStorage.setItem('lastLoanCalculatorEquity', equity);
    };

    protected handleChange = (ev: React.FormEvent<HTMLInputElement>) => {
        const target = ev.target as HTMLInputElement | HTMLSelectElement;

        const state = this.state;
        state[target.name] = Math.max(0, parseFloat(target.value));

        this.setState(state);
    };

    protected handleValueChange = (name: string, value: number) => {
        const state = { ...this.state };

        if (name === 'equity') {
            state.equityBank = value - state.equityStock - state.equityBuildingSociety - state.equityAssurence - state.equityMiscellaneous;
            state.equity = value;
        } else {
            state[name] = Math.max(0, value);
        }

        this.setState(state);
    };

    protected handleToggleClosingCostsDetails = () => {
        this.setState({
            showClosingCostsDetails: !this.state.showClosingCostsDetails,
        });
    };
    protected handleToggleEquityDetails = () => {
        this.setState({
            showEquityDetails: !this.state.showEquityDetails,
        });
    };

    protected handleGoToLoanRequest = (ev: React.FormEvent) => {
        ev.preventDefault();

        this.props.onNextStep({ loanCalculator: { ...this.state } });
        // History.push({
        //     pathname: `/${Config.get('loanRequestRoute')}/${this.props.uuid}`
        // });
    };
}
